export default "__VITE_ASSET__BMLWlDLw__"